/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  NullStorage.ts
 */

import { EnhancedStorage } from './types/EnhancedStorage'

export class NullStorage<TValue = any> implements EnhancedStorage<TValue> {
  readonly length = 0

  clear() {}

  getExpiresInMs(key: string): null {
    return null
  }

  getItem(key: string): null {
    return null
  }

  key(index: number) {
    return null
  }

  removeItem(key: string) {}

  setItem(key: string, value: TValue) {}
}
